import React, { Component } from 'react';
import { connect } from 'react-redux';
import config from 'react-global-configuration';

import { webformGet } from '../../store/actions/Webform';
import WebformComponent from './Component';

// Custom components.
import WebformHidden from '../../components/Webform/Hidden';
import WebformNumber from '../../components/Webform/Number';

class Webform extends Component {
  componentDidMount() {
    const { entities, id, dispatch } = this.props;
    if (!entities) {
      dispatch(webformGet(id));
    }
  }

  componentDidUpdate(prevProps) {
    const { id, dispatch, language } = this.props;
    const MULTILINGUAL = config.get('MULTILINGUAL', true);

    if (prevProps.id !== id || (MULTILINGUAL && prevProps.language !== language)) {
      dispatch(webformGet(id));
    }
  }

  render() {
    const { entities } = this.props;
    if (!entities) {
      return null;
    }

    return (
      <WebformComponent
        {...this.props}
        overriddenComponents={{
          hidden: WebformHidden,
          number: WebformNumber,
        }}
      />
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    entities: ownProps.entities || state.getIn(['webform', ownProps.id, 'fields']),
    info: ownProps.info || state.getIn(['webform', ownProps.id, 'info']),
    language: state.getIn(['ui', 'language']),
  };
}

export default connect(mapStateToProps)(Webform);
